export const TOTAL_NUM_OF_COLUMNS_SHORTCUTS = 7;

export const MAX_SHORTCUT_GROUP_NAME_WIDTH = 300;

export const DIALOG_BODY_PADDING_SHORTCUTS = 3;

export const MAX_URL_LENGTH = 70;
